import { render, staticRenderFns } from "./AdOrderProductInfo.vue?vue&type=template&id=1b90658a&"
import script from "./AdOrderProductInfo.vue?vue&type=script&lang=js&"
export * from "./AdOrderProductInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports